{
    "SectionheaderDatetime": "Date",
    "SectionheaderTimerange": "Tijdsbestek",
    "SectionheaderDaterange": "Aangepaste instellingen",
    "SectionheaderDaysoftheweek": "Dagen van de week",
    "InputlabelBetween": "Tussen:",
    "InputlabelAnd": "En:",
    "RadiolabelRealtime": "Realtime (nu)",
    "RadiolabelToday": "Vandaag",
    "RadiolabelYesterday": "Gisteren",
    "RadiolabelThisweek": "Deze week",
    "RadiolabelLastweek": "Vorige week",
    "RadiolabelThismonth": "Deze maand",
    "RadiolabelLastmonth": "Vorige maand",
    "RadiolabelCustom": "Aangepast...",
    "RadiolabelDays": "dagen:",
    "NAME": "DateTime",
    "SectionHeaderLastXDays": "Laatste 'X' dagen",
    "RadiolabelLastXDays": "Laatste 'X' dagen"
}